<template>
  <div class="text-center">
    <div class="mt-42px">
      <v-icon style="font-size: 45px">insert_drive_file </v-icon>
    </div>
    <div class="mt-14px">
      <button class="btn" @click.self="importFileCancel">
        <v-icon class="mr-2 ink-01-emphasis--text" @click="importFileCancel"
          >attach_file</v-icon
        >
        <span @click="importFileCancel">{{ zip.name }}</span>
        <v-icon class="ml-2 ink-01-emphasis--text" @click="importFileCancel"
          >cancel</v-icon
        >
      </button>
    </div>
    <!--<div class="mt-10px">或將檔案拖曳至此</div>-->
  </div>
</template>

<script>
export default {
  props: {
    zip: {
      type: File,
      default: () => ({}),
    },
  },
  methods: {
    importFileCancel() {
      this.$emit('update:zip', null);
      this.$emit('update:currentStep', 2);
      this.$emit('update:currentStatus', 3);
    },
    updateStatus() {
      this.$emit('update:currentStep', 2);
      this.$emit('update:currentStatus', 3);
    },
  },
};
</script>

<style></style>
